import { FieldError, FieldStatus } from '@/framework/base/components/FieldInfo';
import { Period } from "@/framework/base/helpers/DateFormat";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    props: {
        value: {
            type: [String, Date, Number, null],
            required: true
        },
        min: {
            type: [Number, String]
        },
        max: {
            type: [Number, String]
        },
        periods: {
            type: Array as PropType<Period[]>
        },
        libelle: {
            type: String,
            required: false
        },
        readOnly: {
            type: Boolean
        },
        required: {
            type: Boolean
        },
        contextId: {
            type: Number,
            required: true
        },
        bold: {
            type: Boolean
        },
        hideLabel: {
            type: Boolean
        },
        dataTable: {
            type: Boolean
        },
        theme: {
            type: Number
        },
        showMissing: {
            type: Boolean
        }
    },
    created(): void {
        if (this.value) {
            this.initValue = this.value.toString();
        }
        this.status.objId = this.contextId;
    },
    data() {
        return {
            initValue: '',
            status: new FieldStatus(false, false, 0)
        };
    },
    methods: {
        setInitValue(value: string): void {
            this.initValue = value;
            this.status.objId = this.contextId;
        },
        save(): void {
            if (this.value) {
                this.initValue = this.value.toString();
            }
            this.status.clear(this.contextId);
            this.$emit('status', this.status);
        },
        setUpdated(value: string): void {
            this.status.updated = value != this.initValue;
            this.$emit('update:value', value);
            this.$emit('status', this.status);
        },
        setError(value: FieldError): void {
            this.status.error = value.error;
            this.$emit('status', this.status);
        }
    }
})
